import React from 'react';
import { Route } from 'react-router-dom';
import ForgotPassword from '../ui/ForgotPassword';

const routes = [
	<Route
		key="forgotPassword"
		exact
		noLayout
		path="/forgotPassword"
		render={props => <ForgotPassword {...props}/>}
  />,
];

export default routes;
